// extracted by mini-css-extract-plugin
export var progressContainer = "_g5-0";